var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFab(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 98,
    viewBox: "0 0 98 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_1755_34234)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1755_34234)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 9,
    width: 70,
    height: 70,
    rx: 35,
    fill: "#374DA0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.75 44C55.5114 44 57.75 41.7614 57.75 39C57.75 36.2386 55.5114 34 52.75 34C49.9886 34 47.75 36.2386 47.75 39C47.75 41.7614 49.9886 44 52.75 44Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.75 54C52.75 54 62.75 54 62.75 51.5C62.75 48.5 57.875 45.25 52.75 45.25C47.625 45.25 42.75 48.5 42.75 51.5C42.75 54 52.75 54 52.75 54ZM41.5 41.5V37.75H39V41.5H35.25V44H39V47.75H41.5V44H45.25V41.5H41.5Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_1755_34234",
    x: 0.25,
    y: 0.25,
    width: 97.5,
    height: 97.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.875
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1755_34234"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3.75,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect2_dropShadow_1755_34234"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1755_34234",
    result: "effect2_dropShadow_1755_34234"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1755_34234",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1755_34234"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 9,
    width: 70,
    height: 70,
    rx: 35,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFab);
export default __webpack_public_path__ + "static/media/FAB.de759ed900deb4e04a279ac54048d165.svg";
export { ForwardRef as ReactComponent };